import React from "react";

export default function Comingpage() {
  return (
    <>
      <div className={`max-w-4xl h-screen mx-auto py-5`}>
        <h1 className="text-center mb-4">Some-thing amazing is coming...</h1>
      </div>
    </>
  );
}
